export const apiEndPoints = {
  bulkOrder: {
    getBulkOrderStatusDetails: "/bulk-order/public-status/",
    export: "/bulk-orders/public-status/export/",
  },
};

/**
 * Where closing the order view sends the customer.
 *
 * This used to be the production host written into Order.jsx, so every
 * non-production deploy bounced customers to the live site on close - and
 * `removeTokens()` runs first, so they arrived signed out with no way back to
 * the order they were looking at.
 *
 * `REACT_APP_APP_URL` is baked in at build time and is not guaranteed to be set
 * on every host, and assigning an empty one to `location.href` navigates to the
 * literal string "undefined". Fall back to this app's own root, which is the
 * same destination on every environment.
 */
export const appUrl = () => import.meta.env.REACT_APP_APP_URL || "/";
